import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "txt-center": "" }
const _hoisted_2 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_section_divider = _resolveComponent("app-section-divider")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_app_user_section = _resolveComponent("app-user-section")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_app_user_section, null, {
      default: _withCtx(() => [
        _createVNode(_component_app_section_divider, { content: "Change Password" }),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_image, {
              lazy: "",
              style: `width: 230px;`,
              src: _ctx.img
            }, null, 8, ["src"])
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("p", null, [
            _createTextVNode(" Want to change your password? "),
            _createElementVNode("br"),
            _createTextVNode(" Press the the button below, and we will "),
            _createElementVNode("br"),
            _createTextVNode(" send the instructions in your email inbox ")
          ], -1)),
          _createVNode(_component_el_button, {
            "is-all-borderless": "",
            plain: "",
            type: "primary",
            onClick: _ctx.sendResetIndstructions
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Send Reset Instructions ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    })
  ]))
}